import { i18n } from "../../../translate/i18n";

const normalizeEnum = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const translateEnum = (group, value, fallback) => {
  const key = normalizeEnum(value);
  if (!key || key === "-") return "-";
  const path = `connections.whatsapp.template.table.values.${group}.${key}`;
  const label = i18n.t(path);
  return label === path ? (fallback ?? value ?? "-") : label;
};

export const templateStatusLabel = (status) => translateEnum("status", status, status);

export const templateQualityLabel = (quality) => {
  const raw = String(quality ?? "").trim();
  if (!raw || raw === "-") return "-";
  if (raw.startsWith("{")) return "-";
  return translateEnum("quality", raw, raw);
};

export const templateCategoryLabel = (category) => {
  const key = normalizeEnum(category);
  const map = {
    AUTHENTICATION: "connections.whatsapp.template.modal.categoryOptions.authentication",
    MARKETING: "connections.whatsapp.template.modal.categoryOptions.marketing",
    UTILITY: "connections.whatsapp.template.modal.categoryOptions.utility",
  };
  return map[key] ? i18n.t(map[key]) : category || "-";
};

const LANGUAGE_LABELS = {
  pt_BR: { pt: "Português (BR)", en: "Portuguese (BR)" },
  pt_PT: { pt: "Português (POR)", en: "Portuguese (POR)" },
  es: { pt: "Espanhol", en: "Spanish" },
  es_AR: { pt: "Espanhol (ARG)", en: "Spanish (ARG)" },
  es_ES: { pt: "Espanhol (ESP)", en: "Spanish (ESP)" },
  es_MX: { pt: "Espanhol (MEX)", en: "Spanish (MEX)" },
  en: { pt: "Inglês", en: "English" },
  en_GB: { pt: "Inglês (UK)", en: "English (UK)" },
  en_US: { pt: "Inglês (US)", en: "English (US)" },
  af: { pt: "Africâner", en: "Afrikaans" },
  sq: { pt: "Albanês", en: "Albanian" },
  ar: { pt: "Árabe", en: "Arabic" },
  az: { pt: "Azeri", en: "Azeri" },
  bn: { pt: "Bengali", en: "Bengali" },
  bg: { pt: "Búlgaro", en: "Bulgarian" },
  ca: { pt: "Catalão", en: "Catalan" },
  zh_CN: { pt: "Chinês (CHN)", en: "Chinese (CHN)" },
  zh_HK: { pt: "Chinês (HKG)", en: "Chinese (HKG)" },
  zh_TW: { pt: "Chinês (TAI)", en: "Chinese (TAI)" },
  hr: { pt: "Croata", en: "Croatian" },
  cs: { pt: "Tcheco", en: "Czech" },
  da: { pt: "Dinamarquês", en: "Danish" },
  nl: { pt: "Holandês", en: "Dutch" },
  et: { pt: "Estoniano", en: "Estonian" },
  fil: { pt: "Filipino", en: "Filipino" },
  fi: { pt: "Finlandês", en: "Finnish" },
  fr: { pt: "Francês", en: "French" },
  de: { pt: "Alemão", en: "German" },
  el: { pt: "Grego", en: "Greek" },
  gu: { pt: "Gujarati", en: "Gujarati" },
  he: { pt: "Hebraico", en: "Hebrew" },
  hi: { pt: "Hindi", en: "Hindi" },
  hu: { pt: "Húngaro", en: "Hungarian" },
  id: { pt: "Indonésio", en: "Indonesian" },
  ga: { pt: "Irlandês", en: "Irish" },
  it: { pt: "Italiano", en: "Italian" },
  ja: { pt: "Japonês", en: "Japanese" },
  kn: { pt: "Canará", en: "Kannada" },
  kk: { pt: "Cazaque", en: "Kazakh" },
  ko: { pt: "Coreano", en: "Korean" },
  lo: { pt: "Lao", en: "Lao" },
  lv: { pt: "Letão", en: "Latvian" },
  lt: { pt: "Lituano", en: "Lithuanian" },
  mk: { pt: "Macedônio", en: "Macedonian" },
  ms: { pt: "Malaio", en: "Malay" },
  mr: { pt: "Marata", en: "Marathi" },
  nb: { pt: "Norueguês", en: "Norwegian" },
  fa: { pt: "Persa", en: "Persian" },
  pl: { pt: "Polonês", en: "Polish" },
  pa: { pt: "Panjabi", en: "Punjabi" },
  ro: { pt: "Romeno", en: "Romanian" },
  ru: { pt: "Russo", en: "Russian" },
  sr: { pt: "Sérvio", en: "Serbian" },
  sk: { pt: "Eslovaco", en: "Slovak" },
  sl: { pt: "Esloveno", en: "Slovenian" },
  sw: { pt: "Suaíli", en: "Swahili" },
  sv: { pt: "Sueco", en: "Swedish" },
  ta: { pt: "Tâmil", en: "Tamil" },
  te: { pt: "Telugu", en: "Telugu" },
  th: { pt: "Tailandês", en: "Thai" },
  tr: { pt: "Turco", en: "Turkish" },
  uk: { pt: "Ucraniano", en: "Ukrainian" },
  ur: { pt: "Urdu", en: "Urdu" },
  uz: { pt: "Uzbeque", en: "Uzbek" },
  vi: { pt: "Vietnamita", en: "Vietnamese" },
};

export const templateLanguageLabel = (code) => {
  const key = String(code || "").trim();
  if (!key) return "-";
  const locale = String(i18n.language || "pt").toLowerCase().startsWith("en") ? "en" : "pt";
  const entry = LANGUAGE_LABELS[key];
  if (entry) return entry[locale];
  return key.replace("_", " ");
};

export const templateDateLabel = (value) => {
  if (!value || value === "-") return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const locale = String(i18n.language || "pt").toLowerCase().startsWith("en") ? "en-US" : "pt-BR";
  return date.toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
